import { buildMap } from '@/utils/object';
import { computed, ref } from '@vue/composition-api';
export var Feature;
(function (Feature) {
    Feature["DetailPublish"] = "detailPublish";
    Feature["DuplicateCheck"] = "duplicateCheck";
    Feature["AICheckMode"] = "aiCheckMode";
})(Feature || (Feature = {}));
const defaultMap = {
    [Feature.DetailPublish]: true,
    [Feature.DuplicateCheck]: true,
    [Feature.AICheckMode]: false,
};
const OFF = 0;
const ON = 1;
class FeatureManager {
    feature;
    state;
    constructor(feature) {
        this.feature = feature;
        let initVal = defaultMap[feature];
        const lastVal = localStorage.getItem(feature);
        if (lastVal) {
            initVal = Number(lastVal) === ON;
        }
        this.state = ref(initVal);
    }
    on = () => {
        this.state.value = true;
        localStorage.setItem(this.feature, String(ON));
    };
    off = () => {
        this.state.value = false;
        localStorage.setItem(this.feature, String(OFF));
    };
    toggle = () => {
        if (this.isOn) {
            this.off();
            return;
        }
        this.on();
    };
    get isOn() {
        return this.state.value;
    }
    get isOff() {
        return !this.isOn;
    }
}
const feature = buildMap(Object.values(Feature).map(key => ({ feature: key, manager: new FeatureManager(key) })), obj => obj.feature, obj => obj.manager);
export function useFeatureGate(...features) {
    const query = new URLSearchParams(window.location.search);
    const getValue = (feature) => {
        const queryVal = query.get(feature);
        const val = Number(queryVal);
        if (!queryVal?.length || ![OFF, ON].includes(val)) {
            const lastVal = localStorage.getItem(feature);
            if (lastVal) {
                return Number(lastVal) === ON;
            }
            return defaultMap[feature];
        }
        localStorage.setItem(feature, queryVal);
        return val === ON;
    };
    return Object.assign({}, ...features.map(feature => ({ [feature]: getValue(feature) })));
}
export function useFeatureControl(featureFlag) {
    const featureManager = feature[featureFlag];
    const state = computed(() => featureManager.isOn);
    const { toggle } = featureManager;
    return { [featureFlag]: state, [`${featureFlag}Toggle`]: toggle };
}
